import Route from "@ember/routing/route";
import { service } from "@ember/service";
import ENV from "glesys-controlpanel/config/environment";

export default class extends Route {
  @service ajax;

  model({ token }) {
    return this.ajax
      .post(`${ENV.apiBaseUri}/recovery/details`, { data: { token } })
      .then(({ users }) => {
        return { users, token };
      })
      .catch(() => {
        return { users: [] };
      });
  }

  setupController(controller, model) {
    super.setupController(controller, model);
    controller.setupController(model);
  }
}
